import BancoService from "@/services/BancoService"

export const actions = {
    cadastrarBanco: ({commit, dispatch}) => {
        commit('setBanco', {
            nome: "",
            agencia: "",
            conta: "",
            código_banco: "",
            saldo_atual: "",
        }),
        dispatch('setModalCadastroBanco', true)
    },
    listarBancos: ({commit}, data) => {
        commit('setOverlay', true)
        BancoService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setBancos', res.data)
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarBanco: ({commit, dispatch}, data) => {
        commit('setBanco', {...data})
        dispatch('setModalCadastroBanco', true)
    },
    salvarBanco: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        BancoService.salvar(data)
        .then(res => {
            commit('addBanco', res.data)
            commit('setBanco', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Banco cadastrado.')
            dispatch('setModalCadastroBanco', false)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarBanco: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        BancoService.atualizar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('snackbarInfo', 'Banco atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirBanco: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        dispatch('setModalExcluirBanco', false)
        dispatch('setModalCadastroBanco', false)
        BancoService.excluir(data.id)
        .then(res => {
            commit('removeBanco', data)
            commit('setOverlay', false)
            commit('snackbarError', 'Banco excluído.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao excluir Banco.')
        })
    },
    setModalCadastroBanco: ({commit}, status) => {
        commit('setModalCadastrarBanco', false)
        setTimeout(() => {
            commit('setModalCadastrarBanco', status)
        }, 100);
    },
    setModalExcluirBanco: ({commit}, status) => {
        commit('setModalExcluirBanco', false)
        setTimeout(() => {
            commit('setModalExcluirBanco', status)
        }, 100);
    },
}

export default {}